import React from 'react';
//import { render } from 'react-dom';
import './App.css';
import ResumeHeader from './components/resume-header'
import Topslider from './components/topslider'
import Resumetop from './components/resume-top'
import Resumeabout from './components/resume-about'
import Resumeportafolio from './components/resume-portafolio'
import Footer from './components/footer'
import {BrowserRouter as Router,Switch,Route} from "react-router-dom";
   


function App (){
    return (
      <Router>
        <Switch>
        <Route exact path="/">
          <div className="App">                     
            <ResumeHeader/>
              <Topslider/>             
              <Resumetop/>
              <Resumeabout/>
              <Resumeportafolio/>
              <Footer/>
          </div>
        </Route>
        <Route exact path="/resume">
          <div className="App"> 
              <ResumeHeader/>
              <Resumetop/>
              <Resumeabout/>
              <Resumeportafolio/>
              <Footer/>
          </div>
        </Route>
      </Switch>  
      </Router>
          
    )
}

export default App;
